var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,12.28571V9.99994C19,5.58142,15.86627,2,12.00012,2h-.00024C8.13373,2,5,5.58142,5,9.99994v2.28577L3,18H8a4,4,0,0,0,8,0h5ZM12,20a2.0023,2.0023,0,0,1-2-2h4A2.0023,2.0023,0,0,1,12,20ZM5.819,16,6.8877,12.94641,7,12.62555V9.99994C7,6.69153,9.24292,4,11.99988,4h.00024C14.75708,4,17,6.69153,17,9.99994v2.62561l.1123.32086L18.181,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.06c0078fe6174bf4140792a5eaaf49c1.svg";
export { ForwardRef as ReactComponent };